
import { IAuthenticationParameters } from "./IAuthenticationParameters";


export class AuthenticationParameters implements IAuthenticationParameters
{
    userName: string = "";
    passwordHash: string = "";
}
